module.exports = __webpack_public_path__ + "static/media/21.4dc3f883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/21.jpg
// module id = 390
// module chunks = 0